<template>
  <div id="addUserInfo">
    <van-form @submit="onSubmit">
      <van-field
        v-model="userId"
        name="userId"
        label="userId"
        placeholder="userId"
        :rules="[{message: '请填写userId' }]"
        style="display:none"
      />
      <van-field
        v-model="username"
        name="username"
        label="姓名"
        placeholder="姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
       
      />
      <van-field
        v-model="phone"
        type="phone"
        name="phone"
        label="联系电话"
        placeholder="联系电话"
        :rules="[{ pattern,required: true, message: '请填写联系电话' }]"
       
      />
      <van-field
        v-model="teacher"
        name="teacher"
        label="指导老师"
        placeholder="指导老师"
       :rules="[{ message: '请填写指导老师姓名' }]"
        
      />
      <van-field
        v-model="schoolname"
        name="schoolArea"
        label="学校"
        placeholder="学校"
        :rules="[{ required: true, message: '请填写学校名称' }]"
      />

   

       <van-field
          v-model="studySection"
          readonly
          clickable
          name="studySection"
          :value="value1"
          label="学段选择"
          placeholder="点击选择学段"
          @click="showSection = true"
        />
        <van-popup v-model="showSection" position="bottom">
          <van-picker
            show-toolbar
            :columns="columns"
            @confirm="onConfirm1"
            @cancel="showSection = false"
          />
        </van-popup>

 <van-field
  v-model="shippingAddress"
      readonly
      clickable
      name="shippingAddress"
      :value="value"
      label="地区选择"
      placeholder="点击选择省市区"
      @click="showArea = true"
    />
    <van-popup v-model="showArea" position="bottom">
      <van-area
        :area-list="areaList"
        @confirm="onConfirm"
        @cancel="showArea = false"
      />
    </van-popup>

        

      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          保存
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import areaList from '../../assets/area.js'
import {Dialog} from 'vant';
 export default {
  data() {
    return {
      username: '',
      phone: '',
      teacher:'',
      schoolname:'',
      value1: '',
      value: '',
      userId:'',
      studySection:'',
      grade:'',
      shippingAddress:'',
      showSection:false,
      showArea: false,
      pattern: /^1[3456789]\d{9}$/,
       columns: [
        {
          text: '小学',
          children: [
            {
              text: '一年级',
            },
            {
              text: '二年级',
            },
          ],
        },
        {
          text: '初中',
          children: [
            {
              text: '初一',
            },
            {
              text: '初二',
            },
            {
              text: '初三',
            }
          ],
        },
        {
          text: '高中',
          children: [
            {
              text: '高一',
            },
            {
              text: '高二',
            },
            {
              text: '高三',
            }
          ],
        },
      ],
      areaList // 数据格式见 Area 组件文档
    };
  },
  created() {
      this.userId = sessionStorage.getItem('userId');
  },
  methods: {
    getFileInfo:function(){
       var that = this;
   
       this.$axios
                    .get("http://ysj.fxiang.cn/xstWxUser/selectUserInfo",
                     {params:{
                      userId: this.userId,
                      }})
                    .then(function(res) {
                        that.userId = res.data.id
                        that.username = res.data.username
                        that.phone = res.data.phone
                        that.teacher = res.data.teacher
                        that.schoolname = res.data.schoolArea
                        that.studySection = res.data.studySection+','+res.data.grade
                        that.shippingAddress = res.data.shippingAddress
                    })
                    .catch(function(err) {
                        console.log(err);
                    });
    },
     onConfirm(values) {
      this.value = values.map((item) => item.name).join(',');
      this.shippingAddress = this.value;
      this.showArea = false;
      
    },
      onConfirm1(values) {
      this.value1 = values.join(',');
      this.studySection = this.value1;
      this.showSection = false;
    },
     onSubmit(values) {
       var that = this;
      console.log('submit', values);
       this.$axios
                    .post("http://ysj.fxiang.cn/xstWxUser/updateUserInfo", values)
                    .then(function(res) {
                              Dialog.alert({
                            message: '信息修改成功',
                          }).then(() => {
                            // on close
                          });
                    })
                    .catch(function(err) {
                        console.log(err);
                    });
    },
  },
  mounted () { 
      this.getFileInfo()
    }
};
</script>
